import StudentDashboard from "./components/student-dashboard";

function MyCourses() {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Courses List - Takes remaining height */}
      <div className="h-full">
        <StudentDashboard />
      </div>
    </div>
  );
}

export default MyCourses;
